<template>
  <v-dialog
    v-model="dialogOpen"
    max-width="500"
  >
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <v-autocomplete
          v-model="selectedAgent"
          :loading="loading"
          :items="agents"
          :search-input.sync="search"
          cache-items
          class="mx-4"
          outlined
          hide-details
          label="Search for an Agent"
          return-object
          item-text="full_name"
          item-value="id"
        >
          <template v-slot:item="data">
            <template v-if="(typeof data.item !== 'object')">
              <v-list-item-content v-text="data.item"></v-list-item-content>
            </template>
            <template v-else>
              <v-list-item-content>
                <v-list-item-title v-html="data.item.full_name"></v-list-item-title>
                <v-list-item-subtitle v-html="data.item.email"></v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
        <div class="text-center my-2">
          <v-btn color="primary" @click="submitData">Save</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'AgentSearchDialog',
  props: {
    title: {
      type: String,
      default: 'Search For Agents'
    },
    preload: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data () {
    return {
      dialogOpen: false,
      agents: [],
      selectedAgent: null,
      loading: false,
      search: null
    }
  },
  watch: {
    dialogOpen (val) {
      if(this.preload.id) {
        this.agents           = [this.preload]
        this.selectedAgent    = this.preload
      }
      if(val) this.getDataFromApi();
    },
    search () {
      this.getDataFromApi();
    }
  },
  methods: {
    open () {
      this.dialogOpen = true
    },
    close () {
      this.dialogOpen = false
    },
    getDataFromApi () {
      this.loading = true;

      let queryParams = []

      queryParams.push('f[type]=AGENT')
      if(this.search) queryParams.push('s=' + this.search)

      this.$http.get('users?' + queryParams.join('&'))
        .then(response => {
          this.agents = response.data.items
        })
        .catch(err => {
          console.log(err.response)
          this.$swal.fire('Error', 'Error loading agents', 'error')
        })
        .finally(() => {
          this.loading = false
        })
    },
    submitData() {
      this.$emit('on-save',this.selectedAgent)
      this.close()
    }
  }
}
</script>